export default "__VITE_ASSET__DZFGTQYF__"